import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted} from 'vue';
import {getProcessingContact, getPushProcessingList, signIn} from '@/api/miscellaneous';
import {useRoute, useRouter} from 'vue-router';
import Cookies from 'js-cookie';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'PushProcessingList',
  setup(__props, { expose }) {
  expose();

signIn();
const images = ref([]);
const list = ref([]);
const route = useRoute();
const router = useRouter();

const tel = ref(false);
const isShowTel = ref(false);
const restrictShow = ref(false);

const restrictCode = ref('');
const showCheckIn = ref(false);

onMounted(() => {
    showCheckIn.value = !Cookies.get('isSignIn');
});

const getList = (data?: {id: string; purchaseid: string}) => {
    const {state} = route.query;
    let id: string, purchaseid: string;
    if (state) {
        let a_state = (state as string).split('split');
        id = a_state[0];
        purchaseid = a_state[1];
    } else {
        id = route.query.id as string;
        purchaseid = route.query.purchaseid as string;
    }
    getPushProcessingList(data || {id: id as string, purchaseid: purchaseid as string}).then((res: any) => {
        images.value = res.items[0].imgs;
        list.value = res.items[0].purchaseItem;
    });
};
getList();

const getTell = (id: string): void => {
    getProcessingContact({id})
        .then(res => {
            tel.value = res;
            isShowTel.value = true;
        })
        .catch(e => {
            let {code} = e;
            if ([120].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};

const junmp = (url: string) => {
    window.location.href = url;
};

const __returned__ = { images, list, route, router, tel, isShowTel, restrictShow, restrictCode, showCheckIn, getList, getTell, junmp, ref, onMounted, getProcessingContact, getPushProcessingList, signIn, useRoute, useRouter, Cookies, moment }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})